(function(){
    function init(root){
      if(!root || root.dataset.avInit) return;
      root.dataset.avInit = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if(slides.length === 0) return;
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var dotsWrap = root.querySelector('[data-dots]');
      var mode = root.dataset.transition;
      var cur = 0;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function playVideos(){
        root.querySelectorAll('[data-av-video]').forEach(function(v){
          var slideActive = v.closest('[data-slide]').classList.contains('is-active');
          var visible = v.offsetParent !== null;
          if(slideActive && visible){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }
      function render(){
        slides.forEach(function(s,i){
          s.classList.toggle('is-active', i === cur);
          s.classList.toggle('is-prev', i === (cur - 1 + slides.length) % slides.length);
          if(mode === 'slide'){ s.style.transform = 'translateX(' + ((i - cur) * 100) + '%)'; }
        });
        if(dotsWrap){ Array.prototype.forEach.call(dotsWrap.children, function(d,i){ d.classList.toggle('is-active', i === cur); }); }
        playVideos();
      }
      function go(i){ cur = (i + slides.length) % slides.length; render(); }
      function nextSlide(){ go(cur + 1); }
      function prevSlide(){ go(cur - 1); }

      if(slides.length > 1){
        prev && prev.addEventListener('click', function(){ prevSlide(); restart(); });
        next && next.addEventListener('click', function(){ nextSlide(); restart(); });
        if(dotsWrap){
          slides.forEach(function(_,i){
            var b = document.createElement('button');
            b.className = 'av-hero__dot' + (i===0?' is-active':'');
            b.setAttribute('aria-label','Go to slide ' + (i+1));
            b.addEventListener('click', function(){ go(i); restart(); });
            dotsWrap.appendChild(b);
          });
        }
        var sx = 0, dx = 0, dragging = false;
        var vp = root.querySelector('[data-viewport]');
        vp.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; dragging = true; }, {passive:true});
        vp.addEventListener('touchmove', function(e){ if(dragging){ dx = e.touches[0].clientX - sx; } }, {passive:true});
        vp.addEventListener('touchend', function(){ if(dragging && Math.abs(dx) > 45){ if(dx < 0){ nextSlide(); } else { prevSlide(); } restart(); } dragging=false; dx=0; }, {passive:true});
      }

      var timer = null;
      function autoplayOn(){ return root.dataset.autoplay === 'true' && slides.length > 1 && !reduce; }
      function start(){ if(autoplayOn()){ timer = setInterval(nextSlide, parseInt(root.dataset.speed,10) || 6000); } }
      function stop(){ if(timer){ clearInterval(timer); timer = null; } }
      function restart(){ stop(); start(); }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      window.addEventListener('resize', function(){ playVideos(); });
      document.addEventListener('visibilitychange', function(){ if(document.hidden){ stop(); } else { start(); } });

      render();
      start();
    }
    function boot(){ document.querySelectorAll('.av-hero[id^="av-hero-"]').forEach(init); }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();
